<template>
  <!-- send -->
  <div class="flies-step">
    <h5 class="pt-1">Send</h5>
    <label class="d-block p-5 text-center link-inherit cursor-pointer">
      <i class="icon-style style-add-full"></i>
      <p>Add your files</p>
      <input
        type="file"
        id="add-file"
        multiple="multiple"
        hidden="hidden"
        @click="checkLogin"
        @change="uploadFiles"
      />
    </label>
  </div>
  <!-- end send -->
</template>

<script>
import md5 from "js-md5";
import MyLocalStorage from "../../../utils/MyLocalStorage";
import { getFileType } from "../../../utils/Helpers";
export default {
  name: "MySend",
  model: {
    prop: "transfer"
  },
  props: ["transfer"],
  methods: {
    checkLogin(e) {
      if (!MyLocalStorage.getAccessToken()) {
        $("#login-box").addClass("show");
        e.preventDefault();
      }
    },
    uploadFiles(event) {
      let files = event.target.files;
      let total_size = 0;
      for (let i = 0, len = files.length; i < len; i++) {
        this.transfer.files.push(files[i]);
        this.transfer.filesInfo.files.push({
          key: md5(files[i].name),
          name: files[i].name,
          size: files[i].size,
          type: getFileType(files[i].type, files[i].name),
          modified: files[i].lastModified
        });
        total_size += files[i].size;
      }
      this.transfer.filesInfo.total_num = files.length;
      this.transfer.filesInfo.total_size = total_size;
      this.transfer.filesInfo.host_url = "";
      this.transfer.step = 2;
    }
  }
};
</script>
